import { AbstractError } from './abstract-error'

export class NotImplementedError extends AbstractError {
    constructor(message = 'Not Implemented', options: ErrorOptions = {}) {
        super(message, options)
    }
}
